import React, { useState } from "react";
import { Button, Modal, Textarea, TextInput } from "flowbite-react";
import PurchaseInformation from "./PurchaseInformation";
import OrderItems from "./OrderItems";
import ModalComp from "../../components/ModalComp";
import ProductListPage from "../../pages/ProductListPage";
import AddressInfo from "../../components/AdressInfo";
import { usePurchaseOrder } from "./hooks/usePurchaseOrder";
import { useUserServices } from "../../context/DealerProfile";
import { convertAddressFormat } from "../../utils/utils";

export default function PurchaseOrder() {
  const {
    formData,
    openModal,
    setOpenModal,
    handleInputChange,
    handleItemChange,
    removeItem,
    saveAsDraft,
    handleSubmit,
    setFormData,
    isReturn,
  } = usePurchaseOrder();

  const {  dealerDetail: { parentAccount } } = useUserServices();
  
    console.log("dealer data ---> :", parentAccount.Tax_Rule);

  const [showModal, setShowModal] = useState(false);
  const [poNumber, setPoNumber] = useState("");

  const handleConfirmPO = async () => {
    setShowModal(false);
    await handleSubmit({ poNumber, isPOConfirm: true });
  };

  const {
    dealerDetail: { billingAddresses, inHouseShipping, endCustomerShipping },
  } = useUserServices();

  const billingAddressData = billingAddresses.find(
    (addr) => addr.id === formData?.billingAddresses
  );
  const formattedBilliingAddress = billingAddressData
    ? convertAddressFormat(billingAddressData)
    : {};

  const shippingOptions =
    formData?.whichTypeShipping === "in"
      ? inHouseShipping
      : endCustomerShipping;

  const shippingAddressData = shippingOptions.find((addr) => {
    return (
      addr.id ===
      (formData?.whichTypeShipping === "in"
        ? formData?.inHouseShipping
        : formData?.endCustomerShipping)
    );
  });
  const formattedShippingAddress = shippingAddressData
    ? convertAddressFormat(shippingAddressData)
    : {};

  const { isEdited } = formData;

  console.log({formData});

  return (
    <form onSubmit={handleSubmit} className="space-y-8 max-w-5xl mx-auto p-4">
      <div className="card bg-base-100 shadow-xl py-6 px-10">
        <div className="card-header">
          <h2 className="card-title text-2xl mb-4 font-bold text-center">
            {isReturn ? (
              <span>
                <span className="text-green-500">New</span> Return Order
              </span>
            ) : isEdited ? (
              <span>
                <span className="text-green-500">Edit</span> Order Request
              </span>
            ) : (
              <span>
                <span className="text-red-500">New</span> Order Request
              </span>
            )}
          </h2>
        </div>
        <div className="card-body space-y-6">
          <PurchaseInformation
            handleInputChange={handleInputChange}
            formData={formData}
            isReturn={isReturn}
          />
          <div className="flex flex-wrap gap-4">
            <AddressInfo
              addressType="Billing"
              addressData={formattedBilliingAddress}
            />
            <AddressInfo
              addressType={isReturn?"Pick Up":"Shipping"}
              addressData={formattedShippingAddress}
            />
          </div>

          {!isReturn && <div>
            <label className="label">Remarks</label>
            <Textarea
              name="Remark"
              id="Remark"
              className={`w-1/2 sm:w-full`}
              // onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
              value={
                formData?.Remark ?? formData?.Remark
              }
              onChange={(e) =>
                handleInputChange("Remark", e.target.value)
              }
              rows={4}
            ></Textarea>
          </div>}


          <OrderItems
            setOpenModal={setOpenModal}
            formData={formData}
            handleItemChange={handleItemChange}
            removeItem={removeItem}
            isReturn={isReturn}
          />
        </div>
      </div>
      <div className="flex justify-between items-center mt-6">
        <div className="text-lg font-semibold">
          <span>
            Grand Total:{" "}
            {" $ " +
              formData.Orders_Items.reduce(
                (total, item) =>
                  total + item.Quantity * item?.Distributors_Discount_Price,
                0
              ).toFixed(2)}
            </span>

            {parentAccount.Tax_Rule === "Standard-Rated Supplies" && (
              <span className="block text-red-600 font-bold mt-1">
                ADDITIONAL TAX APPLICABLE
              </span>
            )}
        </div>
        <div className="flex gap-4">
          {/* Back Button */}
          <Button
            type="button"
            onClick={() => window.history.back()}
            className="bg-gray-800 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
          >
            Back
          </Button>
          {/* Back Button */}

          {!isReturn ? (
            <>
              {" "}
              <Button
                onClick={saveAsDraft}
                className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Save as Draft
              </Button>
              <Button
                disabled={formData.Orders_Items.length === 0}
                type="button"
                onClick={() => setShowModal(true)}
                className="bg-green-500 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Place Order
              </Button>
              <Button
                disabled={formData.Orders_Items.length === 0}
                type="submit"
                className="bg-gray-800 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Check Stock Availability
              </Button>
            </>
          ) : (
            <Button
              disabled={formData.Orders_Items.length === 0}
              type="submit"
              className="bg-gray-800 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
            >
              Create Sales Return
            </Button>
          )}
        </div>
        <ModalComp
          tittle={"Add Order Items"}
          acceptTittle={"Add Items"}
          declineTittle={"Proceed"}
          openModal={openModal}
          setOpenModal={setOpenModal}
        >
          <ProductListPage setFormData={setFormData} isReturn={isReturn} />
        </ModalComp>

        {/* Modal for PO Number */}
        <Modal show={showModal} onClose={() => setShowModal(false)}>
          <Modal.Header>
            <h2 className="text-lg font-bold">Enter PO Number</h2>
          </Modal.Header>
          <Modal.Body>
            <TextInput
              placeholder="PO Number"
              value={poNumber}
              onChange={(e) => setPoNumber(e.target.value)}
              required
            />
          </Modal.Body>
          <Modal.Footer>
            {/* Confirm Order Button */}
            <Button
              onClick={handleConfirmPO} // Only call handleSubmit when confirming
              className="bg-blue-500 hover:bg-blue-700 text-white"
            >
              Place Order
            </Button>

            {/* Cancel Button */}
            <Button
              onClick={() => setShowModal(false)} // Only close the modal
              className="bg-gray-300 hover:bg-gray-400"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </form>
  );
}
